<template>
  <!-- 数字化服务详情页面 -->
  <div class="digServiceDetail">
    <!-- 顶部banner背景图 -->
    <div class="top-banner-box">
      <div class="top-banner-img" :style="{ backgroundImage: `url(${headerBgUrl})` }"></div>
    </div>
    <!-- 内容概括 -->
    <div style="height:80px">
      <div class="sumup f-r" id="sumup">
        <span
          v-for="(item, index) in sumupList"
          :key="index"
          @click="goAnchor(item)"
          :class="[(index == 2 && caseList.length == 0) ? 'mar0' : '',curAnchor == item.code ? 'curColor' : '']"
        >
          <span v-if="index !== 2">{{ item.title }}</span>
          <span v-else-if="index == 2 && caseList.length > 0">{{ item.title }}</span>
        </span>
      </div>
    </div>
    <!-- 第一部分 -->
    <div class="wrap1" id="anchor_wrap1">
      <div class="common-title">{{ resolveTitle }}</div>
      <div class="tips">{{ resolveDis }}</div>
      <div class="wrap1-con f-r" style="align-items:center">
        <div class="wrap1-right f-r">
          <div class="picOrVideo">
            <div
              v-if="wrap1pic && !wrap1Video"
              class="wrap1-pic"
              :style="{ backgroundImage: `url(${wrap1pic})` }"
            ></div>
            <div v-else-if="!wrap1pic && !wrap1Video" class="wrap1-pic emptyBg"></div>
            <video-player
              v-else
              class="video-player vjs-custom-skin"
              ref="wrap1Player"
              :playsinline="true"
              :options="playerOptions1"
              @play="onPlayerPlay($event)"
              @pause="onPlayerPause($event)"
            ></video-player>
          </div>
        </div>
        <div class="wrap1-left f-c" style="width:600px;height:360px;justify-content: start;">
          <div class="wrap1-title" style="margin-left:0;margin-top:0">{{ wrap1Name }}</div>
          <div class="wrap1-summary">{{ wrap1summary }}</div>
        </div>
      </div>
    </div>
    <!-- 第二部分 -->
    <div class="wrap2" id="anchor_wrap2">
      <div class="common-title">{{ effectTitle }}</div>
      <div class="tips">{{ effectDis }}</div>
      <div class="f-r wrap2Type">
        <div
          class="typeItem"
          v-for="(item, index) in wrap2TypeList"
          :key="index"
          @click="clickType(index)"
          :class="typeIndex == index ? 'cur' : ''"
        >{{ item.title }}</div>
      </div>
      <div class="wrap1-con f-r">
        <div class="wrap1-left f-c">
          <div class="wrap1-title">{{ wrap2Info.title }}</div>
          <div class="setOut" v-html="wrap2Info.introduce"></div>
          <div v-if="linkUrl" class="seek" @click="goUrl">立即体验 ></div>
        </div>
        <div class="wrap1-right f-r" style="justify-content: center;">
          <div class="picOrVideo">
            <!-- v-if="wrap2pic && !wrap2Video" -->
            <div class="wrap1-pic" :style="{ backgroundImage: `url(${wrap2Info.pic})` }"></div>
            <!-- <div v-else-if="!wrap2pic && !wrap2Video" class="wrap1-pic emptyBg"></div>
            <video-player v-else class="video-player vjs-custom-skin" ref="`wrap2Player`" :playsinline="true"
              :options="playerOptions2" @play="onPlayerPlay($event)" @pause="onPlayerPause($event)">
            </video-player>-->
          </div>
        </div>
      </div>
    </div>
    <!-- 第三部分 -->
    <div class="wrap3" v-show="caseList.length > 0" id="anchor_wrap3">
      <div class="common-title">{{ wrap3title }}</div>
      <el-carousel :interval="50000" arrow="always" class="case-box" trigger="click">
        <el-carousel-item v-for="(item, index) in caseList" :key="index">
          <div class="caseItem f-r">
            <div class="caseItem-pic" :style="{ backgroundImage: `url(${item.pic})` }"></div>
            <div class="caseItem-con">
              <div class="caseItem-title">{{ item.title }}</div>
              <div class="caseItem-summary over-num-lines num-5lines">{{ item.description }}</div>
              <div class="caseItem-detail" @click="goCaseDetail(item.caseId)">查看详情</div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 第四部分 -->
    <div class="wrap4" id="anchor_wrap4">
      <div class="common-title">{{ wrap4title }}</div>
      <div class="wrap4-con f-r">
        <div class="safe f-c" v-for="(item, index) in safeList" :key="index">
          <div class="safe-pic" :style="{ backgroundImage: `url(${item.pic})` }"></div>
          <div class="safe-name">{{ item.name }}</div>
          <div class="safe-con f-c">
            <div class="safeItem" v-for="(el, i) in item.list" :key="i">{{ el }}</div>
          </div>
          <div class="arr"></div>
        </div>
      </div>
    </div>
    <!-- 方案咨询 -->
    <div class="consult f-c" id="anchor_wrap5">
      <div class="common-title" style="margin-bottom:20px">方案咨询</div>
      <div class="consult-con">
        <el-form :model="form" :rules="rules" ref="form" label-width="80px" size="small">
          <el-row :gutter="24">
            <el-col :span="6">
              <el-form-item prop="title" label="需求名称">
                <el-input v-model="form.title" placeholder="需求名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="company" label="企业名称">
                <el-input v-model="form.company" placeholder="企业名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="mobile" label="联系电话">
                <el-input v-model="form.mobile" placeholder="联系电话"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="linkPerson" label="联系人">
                <el-input v-model="form.linkPerson" placeholder="联系人"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item prop="introduce" label="需求内容">
                <el-input
                  type="textarea"
                  placeholder="需求内容"
                  v-model="form.introduce"
                  :autosize="{ minRows: 6, maxRows: 10 }"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="上传文件">
                <el-upload
                  action="/service-center/upload/file/single"
                  :on-success="handleAvatarSuccess"
                  class="hiddenInput"
                  :headers="headers"
                  :before-upload="beforeAvatarUpload"
                  :show-file-list="false"
                >
                  <el-button size="mini" type="primary">选取文件</el-button>
                </el-upload>
                <div class="fileName">
                  <span v-if="!fileName" style="color:red;">*未选择任何文件 注意：单个附件大小不能超过2M</span>
                  <span v-else>{{ fileName }}</span>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <div class="submit" @click="save">提 交</div>
          </el-row>
        </el-form>
      </div>
    </div>
    <!-- 底部联系方式 -->
    <!--     <div class="footer f-c">
      <div class="footer-title">跨行业，多场景数字化解决方案</div>
      <div class="footer-tel">
        <span>电话：123456789123</span>
        <span>邮箱：123456789123</span>
      </div>
      <div class="footer-btn">联系我们</div>
    </div>-->
  </div>
</template>

<script>
import {
  getDictionaryItem,
  getDigServiceDetail,
  DigServiceDetailSave
} from "../../utils/interface";
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      uuid: "",
      headerBgUrl: "",
      headers: {
        Authorization: "Bearer " + this.$cookies.get("api_access_token") //	可以是授权凭证用的参数值
      },
      fileName: "", // 上传得文件名称
      sumupList: [
        { title: "" },
        { title: "" },
        { title: "实施案例" },
        { title: "服务保障" },
        { title: "方案咨询" }
      ],
      resolveTitle: "概述",
      resolveDis: "第一部分概述",
      wrap1Name: "装备制造全流程运营管控平台FOM采用微服务架构(MSA)",
      wrap1summary:
        "基于数百家基于数百家基于数百家基于数百家基于数百家基于数百家基于数百家基于数百家基于数百家基于数百家基于数百家基于数百家基于数百家基于数百家基于数百家",
      playerOptions1: {
        // playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4",
            // src: 'https://zengcai.obs.cn-north-4.myhuaweicloud.com:443/2023-11-25%2Fed61b0036a0b43769ecca69385fe3386.mp4', //你的视频地址（必填）
            src:
              "https://zengcai.obs.cn-north-4.myhuaweicloud.com:443/2023-11-25%2Fed61b0036a0b43769ecca69385fe3386.mp4"
          }
        ],
        poster: "", //你的封面地址
        width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试" //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        //        controlBar: {
        //          timeDivider: true,
        //          durationDisplay: true,
        //          remainingTimeDisplay: false,
        //          fullscreenToggle: true  //全屏按钮
        //        }
      },
      // playerOptions2: {
      //   // playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
      //   autoplay: false, //如果true,浏览器准备好时开始回放。
      //   muted: false, // 默认情况下将会消除任何音频。
      //   loop: false, // 导致视频一结束就重新开始。
      //   preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
      //   language: 'zh-CN',
      //   aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
      //   fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
      //   sources: [{
      //     type: "video/mp4",
      //     // src: 'https://zengcai.obs.cn-north-4.myhuaweicloud.com:443/2023-11-25%2Fed61b0036a0b43769ecca69385fe3386.mp4', //你的视频地址（必填）
      //     src: ''
      //   }],
      //   poster: "", //你的封面地址
      //   width: document.documentElement.clientWidth,
      //   notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
      //   //        controlBar: {
      //   //          timeDivider: true,
      //   //          durationDisplay: true,
      //   //          remainingTimeDisplay: false,
      //   //          fullscreenToggle: true  //全屏按钮
      //   //        }
      // },
      wrap1pic: require("../../assets/publicService/digitalize/22.png"),
      wrap1Video:
        "https://zengcai.obs.cn-north-4.myhuaweicloud.com:443/2023-11-25%2Fed61b0036a0b43769ecca69385fe3386.mp4",
      typeIndex: 0,
      effectTitle: "功能介绍",
      effectDis: "第二部分功能介绍",
      wrap2pic: require("../../assets/publicService/digitalize/22.png"),
      wrap2Video:
        "https://zengcai.obs.cn-north-4.myhuaweicloud.com:443/2023-11-25%2Fed61b0036a0b43769ecca69385fe3386.mp4",
      wrap2Name: "装备制造全流程运营管控平台FOM采用微服务架构(MSA)",
      wrap2TypeList: [
        // { title: '原料入库', list: [{ title: 'MRP物料需求MRP物料需求MRP物料需求MRP物料需求MRP物料需求MRP物料需求MRP物料需求' }, { title: 'MRP物料需求' }, { title: 'MRP物料需求' }] },
      ], // 第二部分分类
      wrap2Info: {},
      wrap3title: "实施案例",
      caseList: [
        // {
        //   pic: require('../../assets/publicService/digitalize/17.png'),
        //   title: '企业初创解决方案1111',
        //   description: '企业初创解决方案具体内容企业初创解决方案具体内容企业初创解决方案具体内容1111111',
        // }
      ], // 案例
      wrap4title: "服务保障",
      safeList: [
        {
          pic: require("../../assets/publicService/digitalize/32.png"),
          name: "售前",
          list: ["痛点咨询", "演示讲解", "案例分享", "解决方案规划"]
        },
        {
          pic: require("../../assets/publicService/digitalize/33.png"),
          name: "售中",
          list: ["实地调研", "方案设计", "方案实施", "系统培训"]
        },
        {
          pic: require("../../assets/publicService/digitalize/34.png"),
          name: "售后",
          list: ["7*24小时系统保障", "在线客服", "定期售后回访", "在线培训"]
        }
      ], // 保障服务List
      form: {
        company: "", // 企业名称
        linkPerson: "", // 联系人
        mobile: "", // 联系电话
        title: "", // 需求名称
        introduce: "" // 需求内容
      },
      rules: {
        company: [
          { required: true, message: "请填写企业名称", trigger: "change" }
        ],
        linkPerson: [
          { required: true, message: "请填写联系人", trigger: "change" }
        ],
        mobile: [
          { required: true, message: "请填写联系电话", trigger: "change" }
        ],
        title: [
          { required: true, message: "请填写需求名称", trigger: "change" }
        ],
        introduce: [
          { required: true, message: "请填写需求内容", trigger: "change" }
        ]
      },
      linkUrl: "", // 判断是否有立即使用按钮
      curAnchor: "" // 当前锚点
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
    this.getOptionsData();
    this.uuid = this.$route.query.uuid;
    this.getDigServiceDetail(this.uuid);
    this.form = {
      company: "", // 企业名称
      linkPerson: "", // 联系人
      mobile: "", // 联系电话
      title: "", // 需求名称
      introduce: "" // 需求内容
    };
    window.addEventListener("scroll", this.menu);
  },
  methods: {
    goAnchor(item) {
      setTimeout(() => {
        window.scrollTo({
          top: document.getElementById(`anchor_${item.code}`).offsetTop - 160,
          behavior: "smooth"
        });
      }, 200);
    },
    // 页面滚动
    menu() {
      let scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      let sumup = document.getElementById("sumup");
      console.log("scroll=", scroll);
      /* 控制标题是否吸附在顶部 */
      if (scroll > 428) {
        sumup.style.position = "fixed";
        sumup.style.top = "80px";
        sumup.style.zIndex = "999";
      } else {
        sumup.style.position = "";
      }
      /* 设置当前锚点控制标题颜色 */
      if (scroll < document.getElementById("anchor_wrap1").offsetTop - 160) {
        this.curAnchor = "";
      } else if (
        scroll >= document.getElementById("anchor_wrap1").offsetTop - 160 &&
        scroll < document.getElementById("anchor_wrap2").offsetTop - 160
      ) {
        this.curAnchor = "wrap1";
      } else if (
        scroll >= document.getElementById("anchor_wrap2").offsetTop - 160 &&
        scroll < document.getElementById("anchor_wrap3").offsetTop - 160 &&
        document.getElementById("anchor_wrap3").offsetTop > 0
      ) {
        this.curAnchor = "wrap2";
      } else if (
        scroll >= document.getElementById("anchor_wrap2").offsetTop - 160 &&
        scroll < document.getElementById("anchor_wrap4").offsetTop - 160 &&
        document.getElementById("anchor_wrap3").offsetTop == 0
      ) {
        this.curAnchor = "wrap2";
      } else if (
        document.getElementById("anchor_wrap3").offsetTop > 0 &&
        scroll >= document.getElementById("anchor_wrap3").offsetTop - 160 &&
        scroll < document.getElementById("anchor_wrap4").offsetTop - 160
      ) {
        this.curAnchor = "wrap3";
      } else if (
        scroll >= document.getElementById("anchor_wrap4").offsetTop - 160 &&
        scroll < document.getElementById("anchor_wrap5").offsetTop - 160
      ) {
        this.curAnchor = "wrap4";
      } else if (
        scroll >=
        document.getElementById("anchor_wrap5").offsetTop - 160
      ) {
        this.curAnchor = "wrap5";
      }
    },
    //顶部背景图
    getOptionsData() {
      getDictionaryItem({
        code: "SZHFWXQ_BANNER"
      }).then(res => {
        if (res != null && res.length > 0) {
          this.headerBgUrl = res[0].value;
        } else {
          this.headerBgUrl = "";
        }
      });
    },
    // 获取详情
    getDigServiceDetail(uuid) {
      getDigServiceDetail(uuid).then(res => {
        if (res && Object.keys(res.data).length > 0) {
          this.playerOptions1.sources[0].src = res.data.videoUrl;
          this.sumupList[0].title = this.resolveTitle = res.data.resolveTitle;
          this.sumupList[1].title = this.effectTitle = res.data.effectTitle;
          this.resolveTitle = res.data.resolveTitle;
          this.resolveDis = res.data.resolveDis;
          this.effectTitle = res.data.effectTitle;
          this.effectDis = res.data.effectDis;
          this.wrap1Name = res.data.title;
          this.wrap1summary = res.data.introduce;
          this.wrap1pic = res.data.pic;
          this.wrap1Video = res.data.videoUrl;
          this.linkUrl = res.data.linkUrl;
          if (res.data.caseList.length > 0) {
            this.caseList = res.data.caseList;
          } else {
            this.caseList = [];
          }
          if (res.data.effectList.length > 0) {
            this.wrap2TypeList = res.data.effectList;
            this.wrap2Info = res.data.effectList[0];
            // this.playerOptions2.sources[0].src = res.data.effectList[0].videoUrl
          } else {
            this.wrap2TypeList = [];
          }
          this.sumupList.forEach((el, index) => {
            el.code = `wrap${index + 1}`;
          });
        } else {
          this.sumupList = [
            { title: "" },
            { title: "" },
            { title: "" },
            { title: "服务保障" },
            { title: "方案咨询" }
          ];
          this.resolveTitle = "";
          this.effectTitle = "";
          this.resolveDis = "";
          this.effectDis = "";
          this.wrap1Name = "";
          this.wrap1summary = "";
          this.wrap1pic = "";
          this.wrap1Video = "";
          this.caseList = [];
          this.wrap2TypeList = [];
        }
        console.log("sumupList==", this.sumupList);
      });
    },
    // 提交
    save() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          DigServiceDetailSave({
            ...this.form,
            ...{ itemUuid: this.uuid }
          }).then(res => {
            if (res && res.success) {
              this.$message({
                showClose: true,
                message: res.message,
                type: "success"
              });
            }
          });
        }
      });
    },
    // 点击type
    clickType(i) {
      this.typeIndex = i;
      this.wrap2Info = this.wrap2TypeList[i];
      // this.playerOptions2.sources[0].src = this.wrap2TypeList[i].videoUrl
    },
    // 点击进入案例详情页
    goCaseDetail(caseId) {
      let routeData = this.$router.resolve({
        path: "/caseDetail",
        query: {
          uuid: caseId
        }
      });
      window.open(routeData.href, "_blank");
    },
    /* 立即使用 */
    goUrl() {
      window.open(this.linkUrl, "_blank");
    },
    beforeAvatarUpload(file) {
      let isLt10M = file.size / 1024 / 1024 < 10;
      let fileNameLength = file.name.length <= 100;
      // let fileTypes = [
      //   ".jpg",
      //   ".png",
      //   ".jpeg",
      //   ".bmp",
      //   ".JPG",
      //   ".PNG",
      //   ".JPEG",
      //   ".BMP",
      // ]
      this.fileName = file.name;
      let fileName = file.name.lastIndexOf(".");
      const fileNameLen = file.name.length;
      const fileTypeName = file.name.substring(fileName, fileNameLen);
      // console.log('fileTypeName:',fileTypeName,'file:',file)
      // let fileIndex = fileTypes.indexOf(fileTypeName)
      // if (fileIndex === -1) {
      //   this.$alert("只能上传jpg/jpeg/bmp/png格式图片", "提示", {
      //     confirmButtonText: "确定",
      //   })
      // } else
      if (!isLt10M) {
        this.$alert("文件大小不能超过10M", "提示", {
          confirmButtonText: "确定"
        });
      } else if (!fileNameLength) {
        this.$alert("文件名（包含后缀名）的最大长度不能超过100个字符", "提示", {
          confirmButtonText: "确定"
        });
      }
      // return isLt10M && fileIndex !== -1 && fileNameLength
      return isLt10M && fileNameLength;
    },
    handleAvatarSuccess() {
      this.$message({
        showClose: true,
        message: "上传成功",
        type: "success"
      });
    },
    onPlayerPlay(player) {},
    onPlayerPause(player) {}
  }
};
</script>
<style lang="less" scoped>
@basic-colors: #2d50a1;

.digServiceDetail {
  position: relative;
  margin-top: -80px;
  background-color: #ffffff;

  .emptyBg {
    background: url("../../assets/publicService/empty.jpg") no-repeat center
      center/100% 100%;
  }

  /* flex布局，竖向分布 */
  .f-c {
    display: flex;
    flex-direction: column;
  }

  /* flex布局，横向分布 */
  .f-r {
    display: flex;
    flex-direction: row;
  }

  .over-num-lines {
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }

  .num-5lines {
    -webkit-line-clamp: 5;
  }

  /* 暂无数据 */
  .empty {
    font-size: 24px;
    font-weight: 500;
    color: #5566779e;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .common-title {
    font-size: 28px;
    font-weight: 600;
    color: #000;
    margin: 20px 0 10px;
    text-align: center;
    position: relative;
  }

  .tips {
    // padding-top: 5px;
    width: 1300px;
    text-align: center;
    min-height: 21px;
    margin: 0 auto;
    padding-top: -18px;
    text-indent: 2em;
    line-height: 25px;
    color: #767474;
  }

  /* 顶部banner */
  .top-banner-box {
    .top-banner-img {
      height: 500px;
      width: 100%;
      overflow: hidden;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  /* 内容总结 */
  .sumup {
    width: 100%;
    height: 80px;
    background-color: #f2f2f2;
    justify-content: center;
    align-items: center;

    .mar0 {
      margin: 0;
    }
    .curColor {
      color: @basic-colors;
    }
    span {
      width: auto;
      margin: 0 30px;
      font-size: 18px;
      font-weight: bold;
      cursor: pointer;
    }
  }

  /* 第一部分、第二部分公共 */
  .wrap1,
  .wrap2 {
    //height: 490px;
    overflow: hidden;

    .wrap1-con {
      height: 420px;
      width: 1300px;
      margin: 0 auto;
      // border: 1px solid #456;
      box-sizing: border-box;
      border-radius: 12px;

      .wrap1-left {
        width: 580px;
        box-sizing: border-box;
        // padding: 0 20px;

        .wrap1-title {
          font-size: 20px;
          font-weight: bold;
          color: @basic-colors;
          width: 420px;
          margin-top: 37px;
          margin-left: 80px;
        }

        .wrap1-summary {
          margin-top: 60px;
          letter-spacing: 1px;
          font-size: 16px;
          color: #445566;
          line-height: 1.5;
        }
      }

      .wrap1-right {
        flex: 1;
        justify-content: start;
        align-items: center;

        .picOrVideo {
          width: 640px;
          height: 360px;

          .wrap1-pic {
            width: 640px;
            height: 360px;
            background: no-repeat center center/100% 100%;
            border-radius: 12px;
          }
        }
      }
    }
  }

  /* 第二部分 */
  .wrap2 {
    //height: 650px;
    overflow: hidden;
    // background: url('../../assets/publicService/digitalize/30.png') no-repeat center center/100% 100%;

    .wrap2Type {
      margin: 0 auto;
      margin-top: 20px;
      margin-bottom: 20px;
      width: 1500px;
      justify-content: center;

      .cur {
        color: #fff;
        background-color: @basic-colors !important;
      }

      .typeItem {
        width: fit-content;
        height: 50px;
        line-height: 50px;
        text-align: center;
        border-radius: 29px;
        background-color: #fff;
        font-size: 20px;
        margin: 0 15px;
        padding: 0 36px;
        cursor: pointer;
      }
    }

    .wrap1-con {
      width: 1300px;
      margin: 0 auto;
      background-color: #f2f4f6de;
      position: relative;
      margin-bottom: 40px;

      .setOut {
        position: relative;
        margin-left: 80px;
        margin-top: 12px;
        font-weight: normal;
        color: #445566;
        line-height: 2.2;
        white-space: pre-wrap;
        max-height: 215px;
        overflow-y: scroll;

        // &::before {
        //   position: absolute;
        //   content: '';
        //   width: 10px;
        //   height: 10px;
        //   border-radius: 50%;
        //   border: 1px solid #2d50a1;
        //   left: -20px;
        //   top: 5px;
        // }
        &::-webkit-scrollbar {
          width: 4px;
        }

        &::-webkit-scrollbar-thumb {
          background-color: #2d50a133;
          border-radius: 2px;
        }

        &::-webkit-scrollbar-track {
          background-color: transparent;
        }
      }
    }

    .seek {
      text-align: center;
      color: @basic-colors;
      position: absolute;
      left: 80px;
      bottom: 40px;
      cursor: pointer;
    }
  }

  /* 第三部分 */
  .wrap3 {
    min-height: 300px;
    width: 100%;
    background-color: #f3f5fb;
    overflow: hidden;

    /deep/ .el-carousel__container {
      height: 380px;
    }

    /deep/ .el-carousel__item {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .case-box {
      .caseItem {
        width: 1300px;
        height: 98%;
        margin: 0 auto;
        justify-content: space-between;
        align-items: center;

        .caseItem-pic {
          width: 580px;
          height: 325px;
          background: no-repeat center center/100% 100%;
          // margin: 0 20px;
          border-radius: 12px;
        }

        .caseItem-con {
          flex: 1;
          height: 325px;
          margin-left: 30px;
          position: relative;

          .caseItem-title {
            font-size: 24px;
            font-weight: bold;
            color: @basic-colors;
          }

          .caseItem-tips {
            height: 64px;
            margin-top: 20px;
          }

          .caseItem-summary {
            max-height: 140px;
            margin-top: 40px;
            color: #445566;
            line-height: 1.75;
          }

          .caseItem-detail {
            position: absolute;
            bottom: 20px;
            left: 0;
            cursor: pointer;
            width: 100px;
            height: 30px;
            line-height: 30px;
            background-color: #2d50a1;
            border-radius: 15px;
            color: #fff;
            font-size: 14px;
            text-align: center;
          }
        }
      }
    }
  }

  /* 第四部分 */
  .wrap4 {
    height: 470px;
    overflow: hidden;
    background-color: #fff;

    .wrap4-con {
      width: 1300px;
      height: 375px;
      margin: 0 auto;
      overflow: hidden;
      justify-content: space-around;
      align-items: center;

      .safe {
        width: 250px;
        height: 360px;
        border-radius: 12px;
        border: 1px solid @basic-colors;
        justify-content: start;
        align-items: center;
        position: relative;
        // box-shadow: 0 0 6px #9999998a;

        &:last-child {
          .arr {
            display: none;
          }
        }

        .arr {
          width: 27px;
          height: 31px;
          background: url("../../assets/publicService/digitalize/35.png")
            no-repeat center center/100% 100%;
          position: absolute;
          right: -110px;
          top: 50%;
          transform: translateY(-50%);
        }

        .safe-pic {
          width: 115px;
          height: 115px;
          background: no-repeat center center/100% 100%;
          margin: 15px 0;
        }

        .safe-name {
          font-size: 24px;
          font-weight: bold;
          margin-bottom: 10px;
        }

        .safe-con {
          justify-content: space-around;
          align-items: center;

          .safeItem {
            width: 185px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            border-radius: 15px;
            background-color: #e5f3fe;
            color: #000;
            margin: 4px 0;
          }
        }
      }
    }
  }

  /* 方案咨询 */
  .consult {
    height: 380px;
    // background: url('../../assets/publicService/digitalize/36.png') no-repeat center center/100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .consult-con {
      width: 1300px;
      height: 320px;
      overflow: hidden;

      .fileName {
        margin-left: 20px;
      }

      .submit {
        width: 100px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        color: #fff;
        background-color: @basic-colors;
        border-radius: 8px;
        margin: 0 auto;
        cursor: pointer;
      }
    }
  }

  /* 底部 */
  .footer {
    height: 300px;
    background: url("../../assets/publicService/digitalize/37.png") no-repeat
      center center/100% 100%;
    justify-content: center;
    align-items: center;
    font-weight: bold;

    .footer-title {
      font-size: 46px;
    }

    .footer-tel {
      font-size: 24px;
      margin: 10px 20px;
    }

    .footer-btn {
      width: 200px;
      height: 62px;
      line-height: 62px;
      text-align: center;
      border-radius: 10px;
      background-color: @basic-colors;
      color: #fff;
      cursor: pointer;
      font-size: 24px;
      letter-spacing: 2px;
      margin-top: 20px;
    }
  }
}

/deep/ .vjs-custom-skin > .video-js .vjs-big-play-button {
  // width: 72px;
  height: 72px;
  // border-radius: 100% !important;
  z-index: 100;
  background-color: #2d50a1;
  border: solid 2px #2d50a1;
}

/deep/ .vjs-poster {
  background-color: #0000;
}

/deep/ .vjs-custom-skin > .video-js .vjs-control-bar {
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}

/deep/ .video-js .vjs-tech {
  border-radius: 14px;
}

/deep/ .vjs-custom-skin > .video-js {
  border-radius: 16px;
}

/deep/ .video-js .vjs-modal-dialog {
  border-radius: 16px;
}

/deep/ .el-input__inner {
  background: #f5f5f5;
  border: none;
}

/deep/ .el-textarea__inner {
  background: #f5f5f5 !important;
  border: none;
}

/deep/ .el-form-item__content {
  display: flex;
}

/deep/ .el-carousel__arrow--left {
  left: 250px;
}

/deep/ .el-carousel__arrow--right {
  right: 250px;
}
</style>


// WEBPACK FOOTER //
// src/components/digitalize/digServiceDetail.vue